import React from 'react';
import { Button, FormGroup, Container, Row, Col, Card, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import authLogo from '../../assets/images/logos/TenantLogo.svg';
import authBg from '../../assets/images/background/auth-bg.png';
import { ReactComponent as LeftBg } from '../../assets/images/bg/login-bgleft.svg';
import { ReactComponent as RightBg } from '../../assets/images/bg/login-bg-right.svg';
import { auditorLogin } from '../../store/slices/authSlice';
import FormInput from '../../components/form/FormInput';
import { decodeToken } from '../../utils/jwtUtils';
import { setLoginUserType } from '../../store/slices/commonSlice';
import { getFullDomain } from '../../utils/common';

const AuditorLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initialValues = {
    domain: process.env.REACT_APP_MODE === 'LOCAL' ? 'call.callex.in' : getFullDomain(),
    username: '',
    password: ''
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().required('Username is required'),
    password: Yup.string().required('Password is required')
  });

  const onSubmit = async (values) => {
    try {
      const payload = {
        ...values
      };
      const data = await dispatch(auditorLogin(payload)).unwrap();
      if (data && data?.success) {
        const user = decodeToken(data?.token);
        dispatch(setLoginUserType(user?.type));
        navigate('/auditor-dashboard');
      } else {
        toast.error('Something went wrong');
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const { values, touched, errors, handleChange, handleSubmit, handleBlur } = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  return (
    <div className="loginBox">
      <LeftBg className="position-absolute left bottom-0" />
      <RightBg className="position-absolute end-0 top" />
      <Container fluid className="h-100">
        <Row className="justify-content-center align-items-center h-100">
          <Col lg="6" md="6" className="d-flex justify-content-center align-items-center">
            <img src={authBg} alt="auth-bg" className="w-75 user-select-none" />
          </Col>
          <Col lg="6" md="6" className="loginContainer">
            <Card>
              <div className="pt-4 d-flex align-items-center justify-content-center gap-2">
                <img src={authLogo} alt="logo" width={120} />
              </div>
              <CardBody className="p-4 m-1">
                <form onSubmit={handleSubmit}>
                  <FormInput
                    name="username"
                    label="Username"
                    value={values.username}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched}
                    errors={errors}
                  />
                  <FormInput
                    name="password"
                    label="Password"
                    type="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched}
                    errors={errors}
                  />
                  <FormGroup className="d-flex align-items-center justify-content-center w-100">
                    <Button type="submit" color="primary" className="me-2 w-100">
                      Login
                    </Button>
                  </FormGroup>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AuditorLogin;
